import React from 'react';
import {
    CL_ORDER_SEARCH_COLUMNS,
    CL_ORDER_STATUS_OPTIONS,
    CL_ORDER_TYPE_OPTIONS,
    DEFAULT_CL_ORDER_FILTERS,
} from './subparts/clOrderRequestQuery';

function ClOrderRequestToolbar({
    isLoading,
    searchTerm,
    searchColumn,
    showAll,
    type,
    status,
    onClearSearch,
}) {
    const searchColumnLabel = CL_ORDER_SEARCH_COLUMNS.find((item) => item.value === searchColumn)?.label;
    const typeLabel = CL_ORDER_TYPE_OPTIONS.find((item) => item.value === type)?.label;
    const statusLabel = CL_ORDER_STATUS_OPTIONS.find((item) => item.value === status)?.label;

    const hasSearch = Boolean(searchTerm?.trim()) && !showAll;
    const hasType = type && type !== DEFAULT_CL_ORDER_FILTERS.type;
    const hasStatus = status && status !== DEFAULT_CL_ORDER_FILTERS.status;
    const hasReset = hasSearch || showAll || hasType || hasStatus;

    if (!hasReset) {
        return null;
    }

    return (
        <div className="optical-dispensary-toolbar">
            <div className="optical-dispensary-toolbar__meta">
                {hasSearch && (
                    <span className="optical-dispensary-chip">
                        <i className="bi bi-funnel" />
                        {searchColumnLabel}: &quot;{searchTerm.trim()}&quot;
                    </span>
                )}
                {showAll && (
                    <span className="optical-dispensary-chip">
                        <i className="bi bi-collection" />
                        All CL order requests
                    </span>
                )}
                {hasStatus && (
                    <span className="optical-dispensary-chip">
                        <i className="bi bi-flag" />
                        Status: {statusLabel}
                    </span>
                )}
                {hasType && (
                    <span className="optical-dispensary-chip">
                        <i className="bi bi-box-seam" />
                        Fulfillment: {typeLabel}
                    </span>
                )}
            </div>

            {hasReset && (
                <div className="optical-dispensary-toolbar__controls">
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary ecx-modal__close-btn"
                        onClick={onClearSearch}
                        disabled={isLoading}
                    >
                        <i className="bi bi-x-lg me-1" />
                        Reset
                    </button>
                </div>
            )}
        </div>
    );
}

export default ClOrderRequestToolbar;
